var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.itemComponent,{tag:"component",attrs:{"data":_vm.completeData,"parent-key":_vm.modulesData && _vm.modulesData.fieldkey,"placeholder":_vm.placeholder},on:{"delete":function($event){return _vm.handleDelete(_vm.data.fieldkey)},"dropdownVisibleChange":_vm.dropdownVisibleChange,"change":_vm.handleChange}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }